export default {
  Picked: 'statusDetails.Picked',
  Packed: 'statusDetails.Packed',
  Labeled: 'statusDetails.Labeled',
  Processing: 'statusDetails.Processing',
  InTransit: 'statusDetails.InTransit',
  OutForDelivery: 'statusDetails.OutForDelivery',
  Delivered: 'statusDetails.Delivered',
  DeliveryException: 'statusDetails.DeliveryException',
  Bundle: 'statusDetails.Bundle',
  MergedItem: 'statusDetails.MergedItem',
  InactiveSku: 'statusDetails.InactiveSku',
  OutOfStock: 'statusDetails.OutOfStock',
  UnknownSku: 'statusDetails.UnknownSku',
  InternalTransferInProgress: 'statusDetails.InternalTransferInProgress',
  BinTransferInProgress: 'statusDetails.BinTransferInProgress',
  InventoryInNonPickableLocation: 'statusDetails.InventoryInNonPickableLocation',
  InventoryPartiallyCommitted: 'statusDetails.InventoryPartiallyCommitted',
  PaymentDeclined: 'statusDetails.PaymentDeclined',
  AddressInvalid: 'statusDetails.AddressInvalid',
  WaitForPickDate: 'statusDetails.WaitForPickDate',
  WaitForShipDate: 'statusDetails.WaitForShipDate',
  NoTariffCode: 'statusDetails.NoTariffCode',
  Manual: 'statusDetails.Manual',
  Shipped: 'statusDetails.Shipped',
  InternationalHazmat: 'statusDetails.InternationalHazmat',
  PackagePreference: 'statusDetails.PackagePreference',
  AutoProcessingPause: 'statusDetails.AutoProcessingPause',
  PickInProgress: 'statusDetails.PickInProgress'
}
